import React from 'react';
import cn from 'classnames';
import {
    Avatar,
    Drawer,
    Grid,
    List,
    ListItem,
    ListItemAvatar,
    ListItemText,
    Typography,
    withStyles
} from "@material-ui/core";
import { Block, CreditCard, LocationOn, Notifications } from "@material-ui/icons";
import If from "../../../components/If";
import { NotificationType } from "../../../apis/firebase/notifications/constant";
import styles from './styles';

const getNotificationIconByType = (type) => {
    if (type === NotificationType.techOnTheWay) {
        return (<LocationOn color='primary'/>)
    } else if (type === NotificationType.paymentOrderRequired) {
        return (<CreditCard color='primary'/>)
    } else if (type === NotificationType.aptmCancelled) {
        return (<Block color='primary'/>)
    } else if (type === NotificationType.techArrived) {
        return (<LocationOn color='primary'/>)
    }
};

const NotificationItem = ({ notification, onClick }) => {
    const { type, title, message, isNew } = notification;
    return (
        <ListItem button
                  onClick={() => onClick(notification)}
                  className="notifItem"
                  component='li'>
            <If as={ListItemAvatar} condition={type !== 0} className="icon">
                <Avatar style={{ backgroundColor: 'transparent' }}>
                    {getNotificationIconByType(type)}
                </Avatar>
            </If>
            <div className="infoContainer">
                <ListItemText primary={title} className="notifTitle"/>
                <ListItemText primary={message} className="notifSubtitle"/>
            </div>
            <If as={'span'} condition={isNew} className="newIndicator"/>
        </ListItem>
    );
};

const NotificationSlider = ({ className, classes, notifications, show, onNotificationClick, onClose }) => (
    <Drawer anchor={"right"} open={show}
            onClose={onClose} className={cn(classes.notificationSlider, className, 'notificationDrawer')}
            PaperProps={{ className: classes.notificationsDiv }}>
        <div className={classes.notifSliderHeader}>
            <h6>NOTIFICATIONS</h6>
            <div className={classes.grow}/>
        </div>
        <If as={Grid} condition={!notifications.length}
            direction='column' container alignItems='center' style={{ marginTop: 30 }}>
            <Grid>
                <Avatar className={classes.transparentAvatar}>
                    <Notifications className={classes.notificationsIcon}/>
                </Avatar>
            </Grid>
            <Grid>
                <Typography variant='subtitle1' style={{ color: '#fafafa' }}>
                    There's no notifications received...
                </Typography>
            </Grid>
        </If>
        <If as={List} condition={notifications.length > 0} className={classes.notifList}>
            {notifications.map(n => (<NotificationItem key={n.id} notification={n} onClick={onNotificationClick}/>))}
        </If>
    </Drawer>
);

export default withStyles(styles)(NotificationSlider);
